export const MENU_WIDTH = 420;
